import React, { useState } from "react";
import { Link } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Light from "./headers/light";
import Footerr from "./footers/Footer";
import { useTranslation } from "react-i18next"; // ✅ Import translation hook
import './BlogSection.css';

const BlogSection = ({ posts }) => {
  const { t } = useTranslation(); // ✅ Initialize translation
  const [activeFilter, setActiveFilter] = useState("All");

  const categories = ["All", ...new Set(posts.map((p) => p.category))];

  const filteredPosts =
    activeFilter === "All"
      ? posts
      : posts.filter((post) => post.category === activeFilter);

  return (
    <AnimationRevealPage>
      <Light />

      {/* Title */}
      <div
        style={{
          padding: "80px 0",
          margin: "0px",
          textAlign: "center",
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          height: "300px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h1
          style={{
            color: "#000000",
            fontWeight: "bold",
            fontSize: "52px",
            margin: 0,
          }}
        >
          {t("Blog")}
        </h1>
      </div>

      <div className="w-full max-w-7xl mx-auto px-6" style={
        {paddingBottom:"100px"}
      }>
        {/* Blog Grid */}
        <div
          className="gap-8"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "32px",
          }}
        >
          {filteredPosts.map((post, index) => (
            <div
              key={index}
              className="bg-white rounded-md shadow-md overflow-hidden flex flex-col"
            >
              {/* Image */}
              <div className="relative w-full h-[300px] rounded-t-md overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow text-center">
                <br />
                <h3 className="post-title mb-3">{t(post.title)}</h3>
                <p className="text-sm text-gray-500 mb-4">
                  {t("Par")} {post.author} • {post.date}
                </p>

                <div className="mt-auto">
                  <Link
                    to={post.link || "#"}
                    className="text-sm px-4 py-2 bg-[#428964] text-black rounded-md hover:bg-[#357a55] transition"
                  >
                    {t("Voir plus")} →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footerr />
    </AnimationRevealPage>
  );
};

export default BlogSection;
